import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    introductionMessage: null,
    phoneNumber: null,
    email: null,
    vehicleBrand: null,
    buyerType: null,
    conversationId: null
  }
}

const state = getDefaultState()

const getters = {}

const mutations = {
  setIntroductionMessage(state, payload) {
    state.introductionMessage = payload
  },
  setPhoneNumber(state, payload) {
    state.phoneNumber = payload
  },
  setEmail(state, payload) {
    state.email = payload
  },
  setVehicleBrand(state, payload) {
    state.vehicleBrand = payload
  },
  setBuyerType(state, payload) {
    state.buyerType = payload
  },
  setConversationId(state, payload) {
    state.conversationId = payload
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}